// configurable id for the tooltip element
const TOOLTIP_ID = 'chart-tooltip';

/**
 * Callback handler for custom rendering of chart.js tooltips. Reads data out of the provided
 *  tooltipModel, and applies it to a created DOM node, positioned as a tooltip.
 *
 * @param {Object} tooltipModel - tooltip object passed from chart.js
 */
export default function(tooltipModel) {
  // Tooltip Element
  let tooltipEl = findOrCreateTooltipEl();

  // Hide and return if no tooltip
  if (tooltipModel.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }

  // `this` will be the overall tooltip
  let chartPosition = this._chart.canvas.getBoundingClientRect();

  setTooltipBody(tooltipModel, tooltipEl);
  setTooltipPosition(tooltipModel, tooltipEl, chartPosition);
}

function findOrCreateTooltipEl() {
  let tooltipEl = document.getElementById(TOOLTIP_ID);

  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.id = TOOLTIP_ID
    tooltipEl.innerHTML = '<table></table>';
    document.body.appendChild(tooltipEl);
  }

  return tooltipEl;
}

/** Reads the data from the tooltip model, and applies to the DOM element as a table. */
function setTooltipBody(tooltipModel, tooltipEl) {
  if (tooltipModel.body) {
    let titleLines = tooltipModel.title || [];
    let bodyLines = tooltipModel.body.map(({ lines }) => lines);

    let titles = titleLines.map((title) => '<tr><th>' + title + '</th></tr>');
    let bodies = bodyLines.map((body) => '<tr><td>' + body + '</td></tr>');

    let tableRoot = tooltipEl.querySelector('table');
    tableRoot.innerHTML = `
      <thead>${titles.join()}</thead>
      <tbody>${bodies.join()}</tbody>
    `;
  }
}

/**
 * Calculates and sets the position of the tooltip using the tooltip model and chart element.
 *
 * @param {Object} tooltipModel - model object from chart.js
 * @param {HTMLElement} tooltipEl - the physical tooltip element
 * @param {DOMRect} chartPosition - bounding rect of the charts position
 */
function setTooltipPosition(tooltipModel, tooltipEl, { top, left }) {
  // Display, position, and set styles for font
  tooltipEl.style.opacity = 1;
  tooltipEl.style.position = 'absolute';
  tooltipEl.style.left = (left + window.pageXOffset + tooltipModel.caretX - (tooltipModel.width/2)) + 'px';
  tooltipEl.style.top = (top - tooltipModel.height) + 'px';
  tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
  tooltipEl.style.fontSize = '12px';
  tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
  tooltipEl.style.padding = `${tooltipModel.yPadding*2}px ${tooltipModel.xPadding}px 0px ${tooltipModel.xPadding}px`;
  tooltipEl.style.pointerEvents = 'none';
}

